jQuery(function(){


    jQuery('body').on('submit', '.policy-change-form__form', function(e){

        e.preventDefault();

        jQuery('.policy-change-form__form-container').addClass('policy-change-form__form-container--hidden');
        jQuery('.policy-change-form__complete-container').removeClass('policy-change-form__complete-container--hidden');

        return false;
    });
});